import { shouldEnableRetrievingRelayTraceID } from 'feature-flags';
import type { PreloadedQuery } from 'react-relay';
import type { OperationType } from 'relay-runtime';

export const getTraceIdFromRelayQueryReference = function <Query extends OperationType>(
    queryReference: PreloadedQuery<Query> | null | undefined
): string | undefined {
    let traceId: string | undefined = undefined;
    if (queryReference && shouldEnableRetrievingRelayTraceID()) {
        const subscription = queryReference.source?.subscribe({
            next: (rawResponse) => {
                if ('extensions' in rawResponse) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    const requestId: string | undefined = rawResponse.extensions?.gateway?.request_id as string;
                    if (requestId) {
                        traceId = requestId;
                    }
                }
            },
            error: () => {
                // keep this callback or fetch error will be throw as uncaught
            },
        });
        subscription?.unsubscribe();
    }
    return traceId;
};
